module.exports = __webpack_public_path__ + "assets/img/title-121557af.png";